export function title(value: string) {
  if (value.toLowerCase() === "hubspot") return "HubSpot";
  return value.split("-").map((part) => part[0]?.toUpperCase() + part.slice(1)).join(" ");
}

export function relative(value: string) {
  const minutes = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 60_000));
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (minutes < 1440) return `${Math.round(minutes / 60)}h ago`;
  return new Date(value).toLocaleDateString();
}
